// CONTROLLER DEPRECATED

// This controller remains for legacy support, but shouldn't be used anymore on new features.
// If you are searching for a non legacy checkbox selector controller please refere to the checkbox_selector_controller.js file.
// Currently this controller is used only on Stakeholder reports new.

// The difference between this controller and the non-lagacy one is that this one
// supports an additional feature that the newer one doesnt.

// We should think on removing this extra feature to a different stimulus controller and
// think how we can connected with the non-legacy controller.

// The additional features involves:
// - Allowing to have more than one parent checkbox. This one can be included on the non-lagacy stimulus controller.
// - Allow the parent checkbox to customize the partially checked state.
//   (This one should be abstracted to a different controller or find the way to not bloat up
//   the non-legacy controller with too much logic.)
//    - Able to define whether the checkbox checked value should be true or false when it's partially checked.
//    - Able to define whether the checkbox skin should be stylized or not as partially checked.

import { Controller } from 'stimulus'
import { useDispatch } from 'stimulus-use'

export default class extends Controller {
  static targets = ['checkbox', 'parentCheckbox', 'totalCheckboxesCheckedIndicator']

  static values = {
    checkboxesCheckedCount: Number
  }

  checkboxesCheckedCountValueChanged() {
    if (this.hasCheckboxesCheckedCountValue) {
      this.dispatch('checkboxesCheckedCountValueChanged', { checkboxesCheckedCount: this.checkboxesCheckedCountValue })
      if (this.hasTotalCheckboxesCheckedIndicatorTarget) {
        this.totalCheckboxesCheckedIndicatorTarget.innerHTML = this.checkboxesCheckedCountValue
      }
    }
  }

  initialize() {
    useDispatch(this)
  }

  connect() {
    this.refreshAll()
    console.warn('Deprecated stimulus controller. Please see file comments for more information.')
  }

  updateCheckboxState(event) {
    this.setCheckboxState(event.currentTarget, event.currentTarget.checked)
    this.updateAllToMatchGeneralState(this.generalState)
  }

  refreshAll(event) {
    // Timeout is set to force waiting on any dom changes to be applied
    setTimeout(() => {
      this.refreshCheckboxesTrackedCount()
      this.refreshCheckboxesCheckedCount()
      this.updateAllToMatchGeneralState(this.generalState)
    }, 0)
  }

  jumpToNextGeneralState(event) {
    switch (this.generalState) {
      case 'AllChecked':
        this.updateAllToMatchGeneralState('NoneChecked')
        break
      case 'NoneChecked':
        this.updateAllToMatchGeneralState('AllChecked')
        break
      case 'SomeChecked':
        this.updateAllToMatchGeneralState('AllChecked')
        break
    }
  }

  setParentCheckboxState(parentCheckboxDom, checkboxesState) {
    const showSomeCheckedParentIcon = (show) => {
      const someCheckedClass = 'c-checkbox__input--partially-checked'
      const showSomeCheckedIcon = parentCheckboxDom.getAttribute(`data-${this.identifier}-use-some-checked`) !== 'false' // this forces it to put the attr when wheen you want it to be false
      if (parentCheckboxDom) {
        if (show && showSomeCheckedIcon) {
          parentCheckboxDom.classList.add(someCheckedClass)
        } else {
          parentCheckboxDom.classList.remove(someCheckedClass)
        }
      }
    }
    // this forces it to put the attr when wheen you want it to be true
    const checkParentOnSomeChecked = parentCheckboxDom.getAttribute(`data-${this.identifier}-checked-on-some-checked`) === 'true'

    switch (checkboxesState) {
      case 'AllChecked':
        parentCheckboxDom.checked = true
        showSomeCheckedParentIcon(false)
        break
      case 'NoneChecked':
        parentCheckboxDom.checked = false
        showSomeCheckedParentIcon(false)
        break
      case 'SomeChecked':
        parentCheckboxDom.checked = checkParentOnSomeChecked
        showSomeCheckedParentIcon(true)
        break
    }
  }

  setCheckboxState(checkboxDom, isChecked) {
    if (checkboxDom.checked !== isChecked) {
      checkboxDom.checked = isChecked
    }

    if (isChecked) {
      this.checkboxesCheckedCountValue = this.checkboxesCheckedCountValue + 1
    } else {
      this.checkboxesCheckedCountValue = this.checkboxesCheckedCountValue - 1
    }
  }

  updateAllToMatchGeneralState(state) {
    this.parentCheckboxTargets.forEach((parentCheckbox) => {
      this.setParentCheckboxState(parentCheckbox, state)
    })

    const updateCheckboxes = (checkAll) => {
      this.checkboxTargets.forEach((checkbox) => {
        if (!checkbox.hasAttribute('disabled') && checkbox.checked !== checkAll) {
          this.setCheckboxState(checkbox, checkAll)
        }
      })
    }

    if (state === 'AllChecked') {
      updateCheckboxes(true)
    } else if (state === 'NoneChecked') {
      updateCheckboxes(false)
    }
  }

  get generalState() {
    switch (this.checkboxesCheckedCountValue) {
      case 0:
        return 'NoneChecked'
      case this._checkboxesTrackedCount:
        return 'AllChecked'
      default:
        return 'SomeChecked'
    }
  }

  refreshCheckboxesTrackedCount() {
    let count = 0
    this.checkboxTargets.forEach((checkbox) => {
      if (!checkbox.hasAttribute('disabled')) {
        count += 1
      }
    })
    this._checkboxesTrackedCount = count
  }

  refreshCheckboxesCheckedCount() {
    let counter = 0
    this.checkboxTargets.forEach((checkbox) => {
      if (!checkbox.hasAttribute('disabled') && checkbox.checked) { counter += 1 }
    })
    this.checkboxesCheckedCountValue = counter
  }
}
